import { ShieldOff } from "lucide-react";

const NotAuthorized = ({ closeNotAuthorized }) => {
  return (
    <div
      onClick={(e) => {
        closeNotAuthorized();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] h-[250px] flex flex-col justify-center items-center gap-[10px] rounded-[20px] p-[20px] relative bg-white"
      >
        <ShieldOff color="#000000" size={40} />
        <h1 className="text-[20px] font-bold">Unauthorized</h1>
        <p>You do not have access to the requested resource.</p>
        <button
          onClick={closeNotAuthorized}
          className="h-[35px] rounded-[30px] bg-[#F3F3F3] px-[20px] text-[#5C5C5C] font-medium text-[15px]"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default NotAuthorized;
